<template>
  <main>
    <div class="navbar-brand">
      <div class="text-center">
        <img id="logo" src="/images/demode.png" alt="Logo" />
      </div>
      <div class="navegacao">
        <div
          class="links"
          :class="{ selected: activeLink === 'dashboard' }"
        >
          <router-link
            to="/dashboard/pagina-inicial"
            @click="setActiveLink('dashboard')"
          >
            <i class="bi bi-house-door" />
          </router-link>
        </div>
        <div
          class="links"
          :class="{ selected: activeLink === 'bag' }"
        >
          <router-link
            to="/dashboard/pedidos"
            @click="setActiveLink('bag')"
          >
            <i class="bi bi-bag" />
          </router-link>
        </div>
        <div
          class="links"
          :class="{ selected: activeLink === 'cut' }"
        >
          <router-link
            to="/dashboard/cortes"
            @click="setActiveLink('cut')"
          >
            <i class="bi bi-scissors" />
          </router-link>
        </div>
        
        <!-- Adicione mais links aqui -->
      </div>
    </div>
  </main>
</template>

<script>
import { ref, onMounted } from "vue";
export default {
  setup() {
    const activeLink = ref("dashboard");

    const setActiveLink = (link) => {
      activeLink.value = link;
    };

    onMounted(() => {
      const currentUrl = window.location.pathname;
      if (currentUrl.includes("/dashboard/pagina-inicial")) {
        setActiveLink("dashboard");
      } else if (currentUrl.includes("/dashboard/pedidos")) {
        setActiveLink("bag");
      } else if (currentUrl.includes("/dashboard/cortes")) {
        setActiveLink("cut");
      } 
      // Adicione mais condições conforme necessário para outros links
    });

    return { activeLink, setActiveLink };
  },
};
</script>

<style scoped>
.navbar-brand {
  padding-top: 2rem;
  background: #ffffff;
  width: 100px;
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1;
}

#logo {
  width: 90% !important;
  object-fit: contain;
}

.navegacao {
}

.links {
  text-align: center;
  margin: 1em;
}

.links i {
  color: #560382;
  font-size: 20pt;
}

.links.selected {
  background-color: #560382;
  border-radius: 5px;
}

.links.selected i {
  color: #ffffff;
}
</style>